import Icon from '../../components/Icon.vue'

Icon.register({"regular/heart":{"width":512,"height":512,"paths":[{"d":"M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5L218.4 464.2C228.4 474.4 241.8 480.1 256 480.1 270.3 480.1 283.6 474.5 293.6 464.3L469 285.6C522.5 230.9 533.7 127.7 458.4 64.3zM434.8 251.8L259.4 430.5C257 432.9 255 432.9 252.6 430.5L77.2 251.8C40.7 214.6 33.3 144.2 84.5 101.1 123.4 68.4 183.4 73.3 221 111.6L256 147.3 291 111.6C328.8 73.1 388.8 68.4 427.5 101 478.6 144.1 471 214.9 434.8 251.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/heart.js
// module id = null
// module chunks = 